import React from 'react';
import { List } from 'react-native-paper';
import { useRouter, usePathname } from 'expo-router';
import styled from '@emotion/native';
import { sand, accent } from '@/shared/styles/colors';
import { SIDE_MENU_ITEMS } from '@/shared/constants/navigation';
import SideMenuItem from '@/shared/components/navigation/SideMenuItem';
import { BREAKPOINTS } from '@/shared/styles/constants';
import useDimensions from '@/shared/hooks/useDimensions';
import { ROUTES } from '@/shared/constants/routes';
import { useIsAdmin } from '@/shared/hooks/useIsAdmin';

const SideMenu = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { width } = useDimensions();

  const isLargeDesktop = width >= BREAKPOINTS.LARGE_DESKTOP;
  const { isAdmin } = useIsAdmin();

  return (
    <SideMenuContainer isLargeDesktop={isLargeDesktop}>
      <LogoContainer
        onPress={() => router.push(ROUTES.SESSIONS.path)}
        accessibilityLabel={`View ${ROUTES.SESSIONS.label}`}
      >
        <StyledImage
          source={require('@/assets/images/EmmeLogoLgGr.png')}
          accessibilityLabel="Emme Logo"
          resizeMode="contain"
          isLargeDesktop={isLargeDesktop}
        />
      </LogoContainer>

      <List.Section>
        {SIDE_MENU_ITEMS.filter(
          (item) =>
            !('requiresAdmin' in item) || !item.requiresAdmin || isAdmin,
        ).map((item) => {
          const title = item.route?.label || item.route.name;
          const path = item.route.path;
          const isActive = path ? pathname === path : false;

          return (
            <SideMenuItem
              key={title}
              icon={{
                type: 'image',
                default: item.default,
                selected: item.selected,
              }}
              title={title}
              isActive={isActive}
              onPress={() => router.push(path)}
              isLargeDesktop={isLargeDesktop}
            />
          );
        })}
      </List.Section>
    </SideMenuContainer>
  );
};

export default SideMenu;

const SideMenuContainer = styled.View<{ isLargeDesktop: boolean }>(
  ({ isLargeDesktop }) => ({
    width: '100%',
    maxWidth: isLargeDesktop ? 283 : 250,
    backgroundColor: sand,
    height: '100%',
    borderRightWidth: 1,
    borderRightColor: accent,
    paddingTop: isLargeDesktop ? 42 : 40,
    paddingRight: isLargeDesktop ? 20 : 24,
    paddingBottom: 0,
    paddingLeft: isLargeDesktop ? 14 : 16,
  }),
);

const LogoContainer = styled.TouchableOpacity({
  paddingLeft: 10,
});

const StyledImage = styled.Image<{ isLargeDesktop: boolean }>(
  ({ isLargeDesktop }) => ({
    height: isLargeDesktop ? 36 : 31.5,
    width: isLargeDesktop ? 110 : 97,
  }),
);
